import React from "react";
import { Link as ScrollLink, animateScroll as scroll } from "react-scroll";
import { H1 } from "../../../styles/Headings.js";
import { P1, P2 } from "../../../styles/Paragraphs.js";
import Button from "../../../styles/Button.js";
import { Highlight } from "../../../styles/Utilities.js";
import { shadows, colors } from "../../../styles/variables.js";
import Image from "../../../components/Image.js";
import SocialNavIcons from "../../../components/SocialNav/SocialNavIcons.jsx";
import resume from "../../../docs/resume.pdf";
import {
   Header,
   HeaderEmail,
   HeaderSocialIcons,
   HeaderButtons,
   HeaderDetails,
   ImageGrid,
   GridItem,
   Buttons,
   GridIcons,
   DownArrow
} from "./HomeHeaderStyles.js";

const gridItemVariant = {
   hidden: {
      y: "100px",
      opacity: 0,
      transition: {
         y: {
            type: "spring",
            duration: 1
         },
         opacity: {
            duration: 1
         }
      }
   },
   visible: i => ({
      y: 0,
      opacity: 1,
      transition: {
         y: {
            type: "spring",
            duration: 1,
            delay: 0.2 + i
         },
         opacity: {
            duration: 1,
            delay: 0.2 + i
         }
      }
   })
};

function HomeHeaderContainer() {
   return (
      <Header>
         <HeaderDetails>
            <P1 dark>Hello, my name is</P1>
            <H1 className="main-heading">
               Paras <Highlight>Arora</Highlight>
            </H1>
            <H1 style={{ color: colors.primary4 }}>I Build Websites.</H1>
            <P2 className="detail">
               I am a{" "}
               <Highlight style={{ fontWeight: 500 }}>MERN stack</Highlight> web
               developer and I create all kinds of amazing websites and web
               apps.
            </P2>
            <HeaderEmail>
               <p className="email-label">Email at :</p>
               <a href="mailto:parasarora594@gmail.com" className="email">
                  parasarora594@gmail.com
               </a>
            </HeaderEmail>
            <HeaderSocialIcons>
               <SocialNavIcons row alignItems="center" size="1.8rem" />
            </HeaderSocialIcons>
            <HeaderButtons>
               <Button
                  as={ScrollLink}
                  to="projects"
                  style={{ marginRight: "1rem" }}
               >
                  Projects
               </Button>
               <Button
                  as="a"
                  href={resume}
                  download="paras-mern-dev-resume.pdf"
                  inverse
               >
                  Resume
               </Button>
            </HeaderButtons>
         </HeaderDetails>
         <ImageGrid>
            <GridItem
               className="one"
               custom={1}
               initial="hidden"
               animate="visible"
               variants={gridItemVariant}
            >
               <Image
                  className="grid-img"
                  src="fanfic-arena-homepage.png"
                  alt="fanfic arena project"
               />
            </GridItem>
            <GridItem
               className="three"
               custom={1.2}
               initial="hidden"
               animate="visible"
               variants={gridItemVariant}
            >
               <Image
                  className="grid-img"
                  src="hotel-montserrat-homepage.png"
                  alt="fanfic arena project"
               />
            </GridItem>
            <GridItem
               className="two"
               custom={1.5}
               initial="hidden"
               animate="visible"
               variants={gridItemVariant}
            >
               <Image
                  className="grid-img"
                  src="url-shortner-homepage.png"
                  alt="fanfic arena project"
               />
            </GridItem>
            <GridItem className="icons">
               <GridIcons
                  custom={1.1}
                  initial="hidden"
                  animate="visible"
                  variants={gridItemVariant}
               >
                  <Image
                     src="icons/node-js-icon.svg"
                     alt="node-icon"
                     style={{ filter: `drop-shadow(${shadows.node})` }}
                  />
                  <Image
                     src="icons/mongodb-icon.svg"
                     alt="mongodb icon"
                     style={{ filter: `drop-shadow(${shadows.mongodb})` }}
                  />
                  <Image
                     src="icons/redux-icon.svg"
                     alt="redux icon"
                     style={{ filter: `drop-shadow(${shadows.redux})` }}
                  />
                  <Image
                     src="icons/javascript-icon.svg"
                     alt="javascript icon"
                     style={{
                        filter: `drop-shadow(${shadows.javascript})`
                     }}
                  />
                  <Image
                     src="icons/react-icon.svg"
                     alt="reactjs icon"
                     style={{ filter: `drop-shadow(${shadows.react})` }}
                  />
                  <Image
                     src="icons/github-icon.svg"
                     alt="github icon"
                     style={{ filter: `drop-shadow(${shadows.github})` }}
                  />
               </GridIcons>
            </GridItem>
         </ImageGrid>

         <DownArrow>
            <Image src="down-arrow.svg" className="arrow-img" />
         </DownArrow>
      </Header>
   );
}

export default HomeHeaderContainer;
